<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               @row-del="rowDel"
               v-model="form"
               ref="crud"
               :permission="permissionList"
               @row-update="rowUpdate"
               @row-save="rowSave"
               :before-open="beforeOpen"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="(page,params)=>{
                  getSpaceListHandler(()=>{
                    onLoad(page,params)
                  });
                }">
               <!-- cycleRange  -->
      <template slot="cycleRange" slot-scope="scope">
        <div>{{scope.row.feeStartTime+'~'+scope.row.feeEndTime}}</div>
      </template>
               <!-- spaceId  -->
      <template slot="spaceIdSearch">
        <selectSearch  v-model="spaceId" :dicData="spacelist"  @change="spaceIdChange"></selectSearch>
          <!-- <el-select
            v-model="spaceId"
            filterable
            placeholder="请选择停车场"
            style="width: 100%"
            @change="spaceIdChange"
          >
            <el-option
              v-for="item in spacelist"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
      </template>
               <!-- spaceId  -->
      <template slot="regionIdSearch">
        
          <el-select
            v-model="regionId"
            filterable
            placeholder="请选择停车场"
            style="width: 100%"
            @change="regionIdChange"
          >
            <el-option
              v-for="item in regionList"
              :key="item.id"
              :label="item.spaceName"
              :value="item.id"
            >
            </el-option>
          </el-select>
      </template>
      <template slot="payTimeSearch">
        <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.payTimeBegin"
              type="datetime"
              default-time="00:00:00"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.payTimeEnd"
              type="datetime"
              default-time="23:59:59"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
            
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>



                
      <template slot="feeStartTimeSearch">
        <el-date-picker
          style="width:100%"
          clearable
          @blur="feeStartTimeChange"
          v-model="feeStartTime"
          type="datetimerange"
          :default-time="['00:00:00','23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>

      
      <template slot="feeEndTimeSearch">
        <el-date-picker
          style="width:100%"
          clearable
          @blur="feeEndTimeChange"
          v-model="feeEndTime"
          type="datetimerange"
          :default-time="['00:00:00','23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>



    </avue-crud>
  </basic-container>
</template>

<script>
  import {getCarparkingSpaceFeeDetailList,
  getRegionList,getSpaceList
   } from "@/api/v4ward/pay/paylog";
  import {mapGetters} from "vuex";
  import dayjs from "dayjs";

  export default {
    data() {
      return {
        spaceId:'',
        regionId:'',
        regionList:[],
        spacelist:[],
        form: {},
        query: {
          carManageType:1,
          payTimeBegin:'',
          payTimeEnd:''
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        payTime:["",""],
        feeStartTime:["",""],
        feeEndTime:["",""],
        // payTime:"",
        selectionList: [],
        option: {
          menu:false,
          height: 'auto',
          calcHeight: 100,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          indexLabel: '序号',
          addBtn:false,
          viewBtn: true,
          selection: true,
          dialogClickModal: false,
          column: [
            {
                  label: '车场名称',
                  prop: 'spaceId',
                  type: 'select',
                  dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
                  props: {
                    label: 'title',
                    value: 'id',
                  },
                  // dataType: 'number',
                  
                  width: 100,
                  search:true,
                  searchslot:true,
                  searchOrder:7,
                  rules: [
                    {
                      required: true,
                      message: '请输入车场名称',
                      trigger: 'change',
                    },
                  ],
            },
            {
                  label: '所属区域',
                  prop: 'regionId',
                  type: 'select',
                  // dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
                  props: {
                    label: 'title',
                    value: 'id',
                  },
                  dataType: 'number',
                  width: 100,
                  search:true,
                  searchslot:true,
                  hide:true,
                  searchOrder:7,
                  rules: [
                    {
                      required: true,
                      message: '请输入车场名称',
                      trigger: 'change',
                    },
                  ],
            },
            
            {
              label: "所属区域",
              prop: "regionName",
              // search: true,
              searchOrder:6,

              rules: [{
                required: true,
                message: "请输入所属区域",
                trigger: "blur"
              }]
            },
            {
              label: "车位编号",
              prop: "parkingSpaceName",
              search: true,
              searchOrder:6,
              rules: [{
                required: true,
                message: "请输入车位编号",
                trigger: "blur"
              }]
            },
            // {
            //       label: '车辆身份',
            //       prop: 'carManageType',
            //       type: 'select',
            //       dicUrl: '/api/blade-system/dict/dictionary?code=car_manage_type',
            //       props: {
            //         label: 'dictValue',
            //         value: 'dictKey',
            //       },
            //       dataType: 'string',
            //       width: 100,
            //       rules: [
            //         {
            //           required: true,
            //           message: '请输入车辆身份',
            //           trigger: 'change',
            //         },
            //       ],
            // },
            // {
            //   label: "车牌号",
            //   prop: "plateNumber",
            //   search: true,
            //   searchOrder:6,
            //   rules: [{
            //     required: true,
            //     message: "请输入车牌号",
            //     trigger: "blur"
            //   }]
            // },
            {
              label: "缴费时长（月）",
              prop: "cycleNum",
              rules: [{
                required: true,
                message: "请输入缴费时长（月）",
                trigger: "blur"
              }]
            },
            {
              label: "缴费周期",
              prop: "cycleRange",
              slot: true,
              rules: [{
                required: true,
                message: "请输入缴费周期",
                trigger: "blur"
              }]
            },
            {
              label: "应收金额",
              prop: "shouldAmount",
              rules: [{
                required: true,
                message: "请输入应收金额",
                trigger: "blur"
              }]
            },
            {
              label: "实收金额",
              prop: "payAmount",
              rules: [{
                required: true,
                message: "请输入实收金额",
                trigger: "blur"
              }]
            },
            // {
            //   label: "收费套餐",
            //   prop: "carFeeRuleName",
            //   rules: [{
            //     required: true,
            //     message: "请输入收费套餐",
            //     trigger: "blur"
            //   }]
            // },
            {
              label: "归属人姓名",
              prop: "personName",
              search: true,
              searchOrder:5,
              searchLabelWidth:100,
              rules: [{
                required: true,
                message: "请输入归属人姓名",
                trigger: "blur"
              }]
            },
            {
              label: "归属人手机",
              prop: "personPhone",
              searchLabelWidth:100,
              search: true,
              searchOrder:4,
              rules: [{
                required: true,
                message: "请输入归属人手机",
                trigger: "blur"
              }]
            },
            {
              label: "支付方式",
              // prop: "payType",
              prop: "payTypeValue",
              rules: [{
                required: true,
                message: "请输入支付方式",
                trigger: "blur"
              }]
            },
            {
              label: "支付时间",
              prop: "payTime",
              type: 'daterange',
              searchOrder:1,
              search:true,
              searchSpan:12,
              searchslot:true,
              rules: [{
                required: true,
                message: "请输入支付时间",
                trigger: "blur"
              }]
            },
            // {
            //   label: "租赁起期",
            //   prop: "feeStartTime",
            //   type: 'date',
            //   search:true,
            //   searchOrder:3,
            //   searchslot:true,
            //   rules: [{
            //     required: true,
            //     message: "请输入支付时间",
            //     trigger: "blur"
            //   }]
            // },
            // {
            //   label: "租赁止期",
            //   prop: "feeEndTime",
            //       type: 'date',
            //       search:true,
            //   searchOrder:2,
            //   searchslot:true,
            //   rules: [{
            //     required: true,
            //     message: "请输入支付时间",
            //     trigger: "blur"
            //   }]
            // },
            
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.client_add),
          viewBtn: this.vaildData(this.permission.client_view),
          delBtn: this.vaildData(this.permission.client_delete),
          editBtn: this.vaildData(this.permission.client_edit)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    mounted(){
      
      this.$nextTick(() => {
        window.onresize = ()=>{
          
                this.$refs.crud.doLayout();
        }
                      this.option.height = this.bodyHeight - 343
              // this.reWrite = true;
              console.log(this.bodyHeight);
              setTimeout(()=>{
              console.log()
             // this.$refs.crud.$el.style.height='50vh';
              // this.$refs.crud.$el.style.overflow='scroll-y';
                    this.$refs.crud.$refs.table.$el.style.cssText = 'height:300px!important';
        console.log(this.$refs.crud);
              console.log(this.$refs.crud.$children[1].$children.length);
              let arrLength = this.$refs.crud.$children[1].$children.length;
              console.log(this.$refs.crud.$children[1].$children[arrLength-2].$el);
              
              this.$refs.crud.$children[1].$children[arrLength-2].$el.addEventListener("click", ()=>{
                // console.log(1212121)
                console.log("this.option.height=====>",this.option.height);
                    if(this.option.height == this.bodyHeight - 284){
                      this.option.height = this.bodyHeight - 543
                    }else{
                      this.option.height = this.bodyHeight - 484;
                    }
                    this.$refs.crud.getTableHeight();
                });
                // getRegionList()
                getSpaceList().then(res=>{
                  this.spacelist = res.data;
                  this.spaceIdChange(res.data[0].id);
                })
                this.$refs.crud.doLayout();
              })
            });
    },
    activated(){
      
                this.$refs.crud.doLayout();
    },
    deactivated(){
      
                this.$refs.crud.doLayout();
    },
    methods: {
      doLayoutHandler(){
        setTimeout(()=>{

          this.$refs.crud.doLayout();
        })
      },
      getSpaceListHandler(cb){

                getSpaceList().then(res=>{
                  this.spacelist = res.data;
                  this.spaceId = res.data[0].id;
                  cb();
                  // this.spaceIdChange(res.data[0].id);
                })
      },
      spaceIdChange(val){
          this.regionId=''
                getRegionList({spaceId:val}).then((res)=>{
                  this.regionList = res.data;
                })
      },
      searchReset() {
        // this.query = {carManageType:1};
        this.query.parkingSpaceName ='';
        this.query.personName = '';
        this.query.personPhone = '';
        this.query.payTimeBegin=''
        this.query.payTimeEnd=''
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query.parkingSpaceName = params.parkingSpaceName;
        this.query.personName = params.personName;
        this.query.personPhone = params.personPhone;
      
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(current) {
        this.page.currentPage = current;
      },
      sizeChange(size) {
        this.page.pageSize = size;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        page = page || this.page;
        console.log('monthcar-log==============>',);
        this.loading = true;
        let date = {};
        console.log(this.feeStartTime,this.feeEndTime,this.payTime);
       
        console.log();
        getCarparkingSpaceFeeDetailList(Object.assign(params, {...{spaceId:this.spaceId,regionId:this.regionId,current: page.currentPage,size: page.pageSize}, ...this.query,...{carManageType:1},...date})).then(res => {
          console.log("getList=======monthcar-log=======>",res.data);
          const data = res.data;
          this.page.total = data.total;
          this.data = data.records;
          this.data.forEach((ele)=>{
            ele.payTime = dayjs(ele.payTime).format('YYYY-MM-DD HH:mm:ss');
            ele.feeStartTime = dayjs(ele.feeStartTime).format('YYYY-MM-DD');
            ele.feeEndTime = dayjs(ele.feeEndTime).format('YYYY-MM-DD');
          })
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>


<style scoped>
::v-deep .avue-crud__pagination {
  height:5vh!important;
}
::v-deep .avue-crud__search {
  height:18vh!important;overflow-y: scroll;
}
::v-deep .el-table {
  height:38vh!important;
}
::v-deep .avue-form__item-- {
  width:100%!important;
}
::v-deep .avue-form__menu--center {
    text-align: right;
}
</style>
